export default "__VITE_ASSET__DEEsY_e6__"